<template>
  <gj-table
      ref="gjTable"
      v-bind="$attrs"
      v-on="$listeners"
      :index="false"
      :loading="loading"
      :data="tableData"
      :columns="proxyColumns"
      :pagination="pagination"
      :adapt-height="adaptHeight"
      :offset-height="offsetHeight"
      :min-height="minHeight"
      :height="height"
      @sort-change="$gjSortChange"
      @page-change="$gjNoticeQuery">
    <template v-slot:userName="{row}">
      {{row.userName || row.createUserName || '-'}}
    </template>
  </gj-table>
</template>

<script>
  import {queryMixin} from "../../minxins";
  import {isMeaningless} from "../../utils/common";

  export default {
    name: "gj-log-table",
    mixins: [queryMixin],
    props: {
      defaultSort:null,
      url: {
        type: String,
      },
      opTypeOption: {
        default: null
      },
      method: {
        type: String,
        default: 'post'
      },
      params: {
        required: false,
        default: () => {}
      },
      adaptHeight: {
        required: false,
        default: true
      },
      columns: {
        type: Array,
        default: null,
      },
      height: {
        type: Number,
        default: null
      },
      minHeight: {
        type: Number,
        default: null
      },
      offsetHeight: {
        type: Number,
        default: null
      },
    },
    data() {
      return {
        tableData: [],
        proxyColumns: []
      }
    },
    watch:{
      url(){
        this.$gjQuery()
      }
    },
    created() {
      if (isMeaningless(this.columns)) {
        this.proxyColumns = [
          {id: 'createDate', header: '操作时间', field: 'createTime', minWidth: '120px'},
          {id: 'opUser', header: '操作用户', field: 'slot:userName', minWidth: '100px'},
          {id: 'op', header: '操作分类', field: this.opTypeOption ? 'option:op' : 'op', options: this.opTypeOption, minWidth: '120px'},
          {id: 'content', header: '操作内容', field: 'content',  overflowLine: 2, minWidth: '300px'}
        ];
      } else {
        this.proxyColumns = this.columns;
      }
    },
    methods: {
      $gjQuery() {
        this.loading = true;
        let param = {
          ...this.params,
          ...this.queryPagination
        };
        if(this.defaultSort){
          param = {
            ...param,
            ...this.querySort
          }
        }
        this.$gjRequest({
          url: this.url,
          method: this.method,
          data: param
        })
          .then(({data}) => {
            if (data) {
              this.tableData = (data.records || []);
              this.pagination = this.getPagination(data);
            } else {
              this.tableData = [];
            }
          })
          .complete(() => this.loading = false);
      }
    }
  }
</script>

<style scoped>

</style>
